//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Heading,
  Stack,
  Text,
  Button,
  ButtonProps,
  VStack,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { IRootStore } from "../../stores";
import {
  CompletedEducationWorkForm,
  CompletedTutorForm,
  LockedForm,
} from "../../tutor-revamp/forms/SharedComponents";
import { useTutorApplicationFlow } from "./data";

export { useTutorApplicationFlow };

const formIds = {
  1: "personal-info",
  2: "location-info",
  3: "education-history",
  4: "work-history",
  // 5: "subject-selection",
  // 6: "verification-info",
  5: "schedule-info",
  6: "agreement-info",
  // 9: "guarantors-info",
  7: "new-development-info",
  8: "payment-info",
  9: "teaching-profile",
};

type FormsetWrapperType = {
  header?: string;
  description?: string;
  buttonText?: string;
  formNo?: string;
  errorMessage?: string;
  shouldDisplayButton: boolean;
  hideStep?: boolean;
  renderButton?: React.ReactNode;
  children: React.ReactNode;
  buttonProps?: any;
};
export const FormsetWrapper: React.FC<FormsetWrapperType> = ({
  children,
  header,
  formNo,
  description,
  shouldDisplayButton,
  errorMessage,
  hideStep = false,
  renderButton,
}) => {
  return (
    <Stack spacing={6}>
      <Stack pb={4}>
        <Text fontWeight="bold" fontSize={["3xl", "4xl"]}>
          {header}
        </Text>
        <Text color="gray.700">{description}</Text>
        {errorMessage && (
          <Alert rounded="lg" status="error">
            <AlertIcon />
            {errorMessage}
          </Alert>
        )}
      </Stack>

      <Stack spacing={6}>{children}</Stack>

      {shouldDisplayButton && renderButton}
    </Stack>
  );
};

const GenericWrapper: React.FC<{
  formNo?: string;
  children: React.ReactNode;
}> = ({ formNo, children }) => {
  return (
    <Stack spacing={6}>
      <Text fontSize="sm" fontWeight="medium" color="gray.700">
        Step {formNo} of {Object.keys(formIds).length}
      </Text>
      <Box>{children}</Box>
    </Stack>
  );
};

const SummaryWrapper: React.FC<{
  displayType: string;
  isCollapsed: boolean;
  shouldDisplayButton?: boolean;
  otherButtonProps?: any;
  buttonText: any;
  loading: boolean;
  onSubmit?: () => any;
  [key: string]: any;
}> = ({
  displayType,
  children,
  isCollapsed,
  shouldDisplayButton,
  otherButtonProps = {},
  buttonText,
  loading,
  onSubmit,
  ...rest
}) => {
  if (isCollapsed) {
    return displayType === "simple" ? (
      <Box width="100%">
        <CompletedTutorForm {...(rest as any)} onSubmit={onSubmit}>
          {children}
        </CompletedTutorForm>
      </Box>
    ) : (
      <Box
        width="100%"
        borderWidth="2xs"
        borderColor="neutral.500"
        p={[6, 8]}
        boxShadow="sm"
        rounded="lg"
      >
        <Text fontWeight="medium" fontSize={["2xl", "3xl"]}>
          {rest.formHeader}
        </Text>

        <CompletedEducationWorkForm {...(rest as any)}>
          {children}
          {shouldDisplayButton && (
            <Button
              alignSelf="flex-start"
              size="lg"
              colorScheme="blue"
              loadingText="Saving details"
              onClick={onSubmit}
              isLoading={loading}
              {...otherButtonProps}
            >
              {buttonText}
            </Button>
          )}
        </CompletedEducationWorkForm>
      </Box>
    );
  }
  return <Box width="100%">{children}</Box>;
};

const FormWrapper: React.FC<{
  activeForm?: number;
  currentEditableForm: string;
  rootStore: IRootStore;
  [key: string]: any;
}> = observer(
  ({
    children,
    activeForm = 1,
    rootStore,
    bgColor = "neutral.200",
    currentEditableForm,
    ...rest
  }) => {
    return (
      <VStack width="100%" spacing={6} {...rest}>
        {React.Children.map(children, (child: any, index) => {
          const spacingProps = { py: [3], mb: [3] };
          if (!child?.props) {
            return null;
          }
          let {
            store,
            formHeader = "",
            formSummary = [],
            formsetDescription = "",
            onSubmit,
            loading,
            Component,
            isCollapsed = true,
            displayType = "simple",
            label = "",
            canEdit = false,
            previousStep = "",
            completed = "",
            lockedDescription = "",
            buttonIsDisabled = false,
            shouldDisplayButton = true,
            buttonText = "",
          } = child.props;
          let RenderComponent = Component
            ? Component
            : displayType === "simple"
            ? GenericWrapper
            : FormsetWrapper;
          let defaultCompleted = canEdit;
          let isCompleted = defaultCompleted;
          // let isCompleted =
          //   defaultCompleted || (rootStore.isEditAction ? true : store.completed);
          let component = React.cloneElement(child, {
            id: formIds[index + 1],
            formNo: index + 1,
            ...spacingProps,
          });
          let gridTemplate =
            formSummary.length === 1 ? "none" : "repeat(2, 1fr)";
          if (currentEditableForm === label) {
            return (
              <Box key={label} width="100%" id={label} {...spacingProps}>
                <Box
                  p={[0, 10]}
                  borderWidth={["none", "2xs"]}
                  borderColor="neutral.500"
                  boxShadow={["none", "base"]}
                  rounded="lg"
                >
                  <RenderComponent
                    {...{
                      header: formHeader,
                      description: formsetDescription,
                      formNo: index + 1,
                      buttonText,
                      buttonProps: {
                        isLoading: loading,
                        onClick: onSubmit,
                        isDisabled: buttonIsDisabled,
                      },
                      shouldDisplayButton,
                    }}
                  >
                    {component}
                  </RenderComponent>
                </Box>
              </Box>
            );
          }
          return isCompleted ? (
            isCollapsed ? (
              <SummaryWrapper
                displayType={displayType}
                formHeader={formHeader}
                formDescription={formsetDescription}
                formSummary={formSummary}
                gridTemplate={gridTemplate}
                onSubmit={onSubmit}
                loading={loading}
                onEdit={() => rootStore.setEditAction(true, label)}
                isCollapsed={isCollapsed}
                shouldDisplayButton={shouldDisplayButton}
                buttonProps={{
                  isLoading: loading,
                  onClick: onSubmit,
                }}
                buttonText={buttonText}
              >
                {component}
              </SummaryWrapper>
            ) : (
              component
            )
          ) : (
            <Box width="100%">
              <LockedForm title={formHeader} description={lockedDescription} />
            </Box>
          );
        })}
      </VStack>
    );
  },
);

export default FormWrapper;

export const FormContainer = ({
  heading,
  description,
  children,
  Component,
  ...rest
}) => {
  return (
    <Box pt={[0, 16]} pb={[0, 8]} {...rest}>
      <Box rounded="fbRadius" bg="white" shadow={["none", "fbShadow"]}>
        <Stack spacing={6} px={[5, 6, 10, 10, 20]} py={[10, 10, 12, 12]}>
          <Stack spacing={3}>
            <Heading fontWeight="bold">{heading}</Heading>
            <Text fontSize="lg" opacity={0.9} lineHeight="tall">
              {description}
            </Text>
          </Stack>

          {children}
        </Stack>
      </Box>
    </Box>
  );
};
